import React from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function EmpathyStory() {
  const checkoutUrl = 'https://www.yennilemon.com/cart/44211058212999:1';
  return <section className="bg-[#F5EFE6] py-16 md:py-24 px-4" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-47">
          <span className="text-sage font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-48">
            ¿Te identificas?
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive" data-id="element-49">
            Sabemos lo que estás sintiendo
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="space-y-6 text-lg text-warm-gray leading-relaxed" data-id="element-50">
          <p data-id="element-51">
            Has hecho dietas. Te cuidas. Haces ejercicio cuando puedes. Pero tu
            cuerpo ya no responde como antes.
          </p>
          <p data-id="element-52">
            Te miras al espejo y sientes que algo cambió. La ropa que antes te
            quedaba perfecta ahora aprieta en lugares nuevos. Y lo peor es que
            no entiendes por qué.
          </p>

          <div className="my-10 pl-6 md:pl-8 border-l-4 border-sage py-2" data-id="element-53">
            <p className="text-xl md:text-2xl font-heading font-medium text-olive italic leading-snug" data-id="element-54">
              "Si estoy haciendo todo bien... ¿por qué mi cuerpo no colabora?"
            </p>
          </div>

          <p className="font-medium text-olive" data-id="element-55">
            No estás haciendo nada mal. Tu cuerpo simplemente cambió, y
            necesitas una nueva manera de acompañarlo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-56">
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} className="inline-block bg-olive hover:bg-olive-light text-white font-bold py-4 px-10 rounded-full transition-all transform hover:scale-[1.02] shadow-md text-lg" data-id="element-57">
            Quiero entender qué me pasa
          </a>
        </motion.div>
      </div>
    </section>;
}